module.exports = __webpack_public_path__ + "img/img_register_1.9f64a468.png";